import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { GLPolicy } from "../models/glPolicy.model";
import { PostedClaimGLAdjustment } from "../models/postedClaimGLAdjustment.model";
import { PostedRemittanceGLAdjustment } from "../models/postedRemittanceGLAdjustment.model";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class GLPolicyService {
  private readonly Timeout: number = 30000;
  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService,
  ) {}

  public async getGLPolicies(
    clientId: string,
    adjustmentType: string,
  ): Promise<GLPolicy[]> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/GLPoliciesForClient/${adjustmentType}`;

    const response = await this.http
      .get<{ Items: GLPolicy[] }>(url, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
        return [];
      });

    if (!response) {
      return [];
    }

    return response.Items || [];
  }

  public async postClaimGLAdjustment<T>(
    clientId: string,
    postedGLAdjustment: PostedClaimGLAdjustment,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/GL/ClaimAdjustments`;
    const response = await this.http
      .post(url, postedGLAdjustment, {
        headers: this.apiBase.getHeaders(),
        responseType: "text" as "json", // API returns a Ok with no content, but HttpClient expects JSON by default. This forces it to accept a string response.
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });

    return response;
  }

  public async postRemittanceGLAdjustment<T>(
    clientId: string,
    postedGLAdjustment: PostedRemittanceGLAdjustment,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/GL/RemittanceAdjustments`;
    let response = await this.http
      .post(url, postedGLAdjustment, {
        headers: this.apiBase.getHeaders(),
        responseType: "text" as "json", // API returns a Ok with no content, but HttpClient expects JSON by default. This forces it to accept a string response.
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/gl-policy.service.ts